module.exports = __webpack_public_path__ + "ecsLogo.png?747dfa1a821995bb691ab03b31d368f2";